import { Typography } from 'antd';
import type { OperatorSectionPageViewProps } from './OperatorSectionPage.types';

const { Title, Text } = Typography;

export function OperatorSectionPageView({
  title,
  description,
}: OperatorSectionPageViewProps) {
  return (
    <div className="app-page">
      <Title level={3} className="ds-page-title" style={{ marginBottom: 8 }}>
        {title}
      </Title>
      <Text type="secondary">{description}</Text>
    </div>
  );
}
